import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import WhatsNewCardDesign from "../../CommonComponents/CardsDesign/WhatsNewCardDesign";
import { SkeletonWhatsNewCard } from "../../CommonComponents/SkeletonUI/LandingPageSkeleton";

import { cardTitleToPath } from "../../../Utils/Constant";
import { HighlightedText } from "../../../Utils/CommonFunctions";

import { useAuth } from "../../../hoc/AuthContext";

import { LeftArrowIcon, RightArrowIcon } from "../../../assets/svg";

export default function WhatNewSection({ isAuthenticated, whatsNewCardData, handleLinkClick, isLoading, websiteLandingPageInfo }) {
  const { integratorTheme } = useAuth();
  const swiperRef = useRef(null); // Ref to access the Swiper instance
  const [currentSlide, setCurrentSlide] = useState(0); // Track current slide index

  const filteredData = whatsNewCardData?.filter(item => item?.brand?.bg_image) || [];
  const totalSlides = filteredData?.length;

  const handlePrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
      setCurrentSlide(swiperRef.current.swiper.activeIndex);
    }
  };

  const handleNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
      setCurrentSlide(swiperRef.current.swiper.activeIndex);
    }
  };

  return isLoading ? (
    <SkeletonWhatsNewCard />
  ) : (
    <>
      {filteredData !== null && filteredData.length > 0 ? (
        <div className="bg-[#f7f7f7] my-8 py-5 md:py-10">
          <div className="container flex flex-col pl-5 -pr-5 md:px-5 mx-auto relative">
            <div className="flex gap-[10px] items-center justify-between">
              {websiteLandingPageInfo?.new_reward_section && (<div className="font-Inter text-xl md:text-3xl font-semibold w-3/4 md:w-full">
                <HighlightedText
                  text={websiteLandingPageInfo?.new_reward_name}
                  integratorTheme={integratorTheme}
                />
              </div>)}
              <button onClick={handlePrev} className="carousel-custom-arrow left-arrow">
                <LeftArrowIcon className={`w-[24px] h-[24px] md:w-[35px] md:h-[35px] stroke-[${currentSlide === 0 ? "#737373" : "#000"}]`} />
              </button>

              <button onClick={handleNext} className="carousel-custom-arrow right-arrow">
                <RightArrowIcon className={`w-[24px] h-[24px] md:w-[35px] md:h-[35px] stroke-[${currentSlide === totalSlides - 1 ? "#737373" : "#000"}]`} />
              </button>
            </div>

            <div className="carousel-wrapper">
              <Swiper
                ref={swiperRef}
                modules={[Navigation, Autoplay]}
                spaceBetween={16} // Space between slides
                slidesPerView={4} // Default number of slides per view
                autoplay={{ delay: 5000, disableOnInteraction: false }} // Autoplay configuration
                onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex)} // Update current slide index
                loop={true}
                breakpoints={{
                  // Responsive breakpoints
                  1301: { slidesPerView: 4 },
                  1281: { slidesPerView: 4 },
                  1025: { slidesPerView: 3 },
                  900: { slidesPerView: 2.6 },
                  801: { slidesPerView: 2.4 },
                  769: { slidesPerView: 2.3 },
                  601: { slidesPerView: 3 },
                  541: { slidesPerView: 2.6 },
                  461: { slidesPerView: 2.3 },
                  401: { slidesPerView: 2 },
                  371: { slidesPerView: 1.8 },
                  321: { slidesPerView: 1.5 },
                  0: { slidesPerView: 1 },
                }}
                className="whatNewCardHeight"
              >
                {filteredData.map((item, index) => {
                  const path = cardTitleToPath(item?.offer_type);
                  return (
                    <SwiperSlide key={index}>
                      <Link
                        to={isAuthenticated ? `/rewards/${path}/${item?.id}/${item?.slug}` : "/"}
                        onClick={() => handleLinkClick(item, { popularCategory: false }, false, false)}
                        className="flex justify-between relative ml-1"
                      >
                        <WhatsNewCardDesign item={item} />
                      </Link>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
